import { motion } from "framer-motion";
import { Clock, ShieldCheck, Gift } from "lucide-react";
import AnalysisForm from "@/components/landing/AnalysisForm";

const perks = [
  { icon: Clock, title: "24 Saatte Dönüş", text: "Başvurunuz aynı gün incelemeye alınır, raporunuz 24 saat içinde hazırlanır." },
  { icon: Gift, title: "Tamamen Ücretsiz", text: "Ön analiz ve yol haritası için hiçbir ücret ödemezsiniz, taahhüt yoktur." },
  { icon: ShieldCheck, title: "Verileriniz Güvende", text: "Paylaştığınız bilgiler yalnızca analiz amacıyla kullanılır, üçüncü kişilerle paylaşılmaz." },
];

export default function FormSection() {
  return (
    <section id="form" className="py-16 sm:py-24 lg:py-32 bg-[#F1F5F9]/60 border-y border-[#E2E8F0]" data-testid="form-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="lg:sticky lg:top-32"
          >
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#0000FF] font-semibold">Ücretsiz Ön Analiz Formu</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0F172A] mt-4">
              Firmanızın Dijital Röntgenini Çekelim
            </h2>
            <p className="text-base leading-relaxed text-[#475569] mt-4">
              Formu doldurun, Kobi-Line danışmanlarımız 24 saat içerisinde şirketiniz için
              özel hazırlanan dijital dönüşüm raporu ile dönüş yapsın.
            </p>
            <div className="mt-8 space-y-5">
              {perks.map((perk) => (
                <div key={perk.title} className="flex gap-4">
                  <div className="shrink-0 w-10 h-10 rounded-xl bg-white border border-[#E2E8F0] grid place-items-center text-[#0000FF]">
                    <perk.icon size={18} />
                  </div>
                  <div>
                    <p className="font-semibold text-[#0F172A] text-sm">{perk.title}</p>
                    <p className="text-sm text-[#475569] mt-0.5">{perk.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
        <div className="lg:col-span-7">
          <AnalysisForm />
        </div>
      </div>
    </section>
  );
}
